import { SwitchButton, DatePicker } from "components/base";
import { isAfter, endOfDay } from "date-fns";

interface ComponentProps {
  defaultOpt: "am" | "pm";
}

const { TimePicker } = DatePicker;

export default function TimeContainer(props: ComponentProps) {
  const { defaultOpt } = props;
    console.log("time filter in issue")
  return (
    <article className="time-container">
      <TimePicker
        defaultValue={new Date()}
        format="HH:mm"
        placeholder="Select"
        disabledDate={(current: Date) => {
            // Disable all future dates after today
            return isAfter(current, endOfDay(new Date()));
        }}
      />
      <SwitchButton
        label=""
        options={["am", "pm"]}
        defaultOption={defaultOpt}
        type="primary"
      />
    </article>
  );
}
